import BaseParagraph from "@common/components/Paragraph/Paragraph";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { vars } from "@common/styles";
import styled from "styled-components";

export const Paragraph = styled(BaseParagraph)`
  a {
    color: ${vars.colors.grey40};
  }
`;

export const IntegrationLayoutSettings = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const IntegrationLayoutList = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const IntegrationLayoutEntry = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.4rem;
  align-items: center;
`;

export const IntegrationLayoutEntryOrderBox = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid ${vars.colors.grey80};
  background: ${vars.colors.grey90};
  border-radius: 1.6rem;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
`;

export const MoveItemButton = styled.button<{ disabled?: boolean }>`
  outline: none;
  border: none;
  background: none;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  padding: 0;
  border-radius: 2rem;
  width: 1.8rem;
  height: 1.8rem;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  :hover {
    background: ${(props) => (props.disabled ? "none" : vars.colors.grey70)};
  }
`;

export const MoveItemTooltip = styled(Tooltip)`
  width: 1.8rem;
  height: 1.8rem;
`;

export const MoveItemIcon = styled.img`
  width: 1.8rem;
  height: 1.8rem;
`;

export const MoveItemText = styled(Paragraph)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MetadataKeyList = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 9rem;
  margin-bottom: 0.6rem;
  margin-top: 0.2rem;
  gap: 0.8rem;
`;

export const MetadataKeyEntry = styled.div`
  display: flex;
  align-items: center;
`;
